import React from 'react';

const Heading = (props) => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <h1 className="page-header" style={{ margin: '20px 0 20px' }}>
                    {props.title}
                </h1>
            </div>
        </div>);
}

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Heading/index.js